// LoginPage.tsx
import React, { useEffect, useState } from "react";
import AuthenticationModal from "../../components/AuthenticationModal";
import { useAuth } from "src/contexts/AuthContext";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";

// For demonstration only, using inline error handling
const LoginPage: React.FC = () => {
    const { firebaseUser } = useAuth();
    const navigate = usePartnerAwareNavigate();

    useEffect(() => {
        // If the user is already logged in, navigate away from the login page.
        if (firebaseUser) {
            navigate("/"); // or wherever your main page/route is
        }
    }, [firebaseUser, navigate]);
    return (
        <div>
            <AuthenticationModal />
        </div>
    );
};

export default LoginPage;
